import GradesPage from './GradePage';

export default GradesPage;
